export default customElements.define('w-fieldset', class Fieldset extends wealthify.CustomElementBaseClass {

    #fields = [];

    constructor() {
        const styleSelector = 'c-fieldset';
        const config = {
            styleSelector,
            templateHTML: `
            <fieldset class="${styleSelector}__container" data-root>
                <legend class="${styleSelector}__label-container u-display__none" data-labelcontainer>
                    <span class="${styleSelector}__legend" data-legend></span>
                    <span class="${styleSelector}__pre-label" data-prelabel></span>
                </legend>
                <div data-child-root></div>
            </fieldset>`,
            hasChildren: true,
            cacheDom: [ 'data-legend', 'data-prelabel', 'data-labelcontainer' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            this.addEventListener('fieldadded', this.#initialiseField, true);
        };
    }

    static get validStateEnums () {
        return {
            Normal: 'normal',
            Error: 'error'
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('legend', {default: ''}),
            new wealthify.Prop('prelabel', {default: ''}),
            new wealthify.Prop('state', {
                default: 'normal',
                type: wealthify.propTypes.ArrayItem(Object.values(this.validStateEnums))
            })
        ];
    }

    get propCallbacks () {
        return {
            legend: () => {
                this.#toggleLabelContent(this.legend, this.dom.legend);
                this.#toggleLabelContainer();
            },
            prelabel: () => {
                const componentClassListAction = this.prelabel === '' ? 'remove' : 'add';

                this.#toggleLabelContent(this.prelabel, this.dom.prelabel);
                this.#toggleLabelContainer();   
                this.classList[componentClassListAction](`${this.styleSelector}--with-prelabel`);
            },
            state: () => {
                Object.values(this.constructor.validStateEnums).forEach((stateValue) => {
                    this.classList.remove(`${this.styleSelector}--state-${stateValue}`);
                });

                this.classList.add(`${this.styleSelector}--state-${this.state}`);
            }
        };
    }

    get valid () {
        return this.state !== this.constructor.validStateEnums.Error && this.#fieldsValid;
    }

    get values () {
        if (this.#fields.length === 0) {
            return wealthify.error.throwError(this.tagName, 'Fields component must contain at least 1 field.');
        }

        return this.#fields.map((field) => field.value ?? '');
    }

    get #fieldsValid () {
        if (this.#fields.length === 0) {
            return wealthify.error.throwError(this.tagName, 'Fields component must contain at least 1 field.');
        }

        return this.#fields.every((field) => field.valid);
    }

    get fields () {
        return this.#fields;
    }

    #toggleLabelContent (value, element) {
        const classListAction = value === '' ? 'add' : 'remove';

        element.innerHTML = value;
        element.classList[classListAction]('u-display__none');
    }

    #toggleLabelContainer () {
        const classListAction = this.legend === '' && this.prelabel === '' ? 'add' : 'remove';

        this.dom.labelcontainer.classList[classListAction]('u-display__none');
    }

    #initialiseField (event) {
        const field = event.target;

        this.#fields.push(field);
    }

});